export default __webpack_public_path__ + "static/bubble_yum-1274baec364a7cb77761d184c834a6f6.png";